import api from 'Application/api/api';

const deleteCampaign = (signal, id) =>
	api.delete(`/finances/${id}`, {
		signal,
	});

export default deleteCampaign;
